import React from "react";

type AmpArticleProps = {
  imageUrl?: string;
  imageWidth?: string | number;
  imageHeight?: string | number;
  category: string | React.ReactNode;
  title: string | React.ReactNode;
  content: string;
};

export function AmpArticle(props: AmpArticleProps) {
  const { imageUrl, imageWidth, imageHeight, category, title, content } = props;

  return (
    <div className="article">
      {imageUrl ? (
        <div className="article__amp-img">
          <amp-img
            className="contain"
            layout="fill"
            src={convertToNextImage(imageUrl)}
            width={imageWidth}
            height={imageHeight}
          ></amp-img>
        </div>
      ) : null}

      <div className="article__category">{category}</div>
      <h1
        className="article__title"
        dangerouslySetInnerHTML={{ __html: `${title}` }}
      />
      <div className="article__content">
        <div
          className="formatted-text"
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        />
      </div>
    </div>
  );
}

export default AmpArticle;

// Converts an image source to a dynamic next image if it's an internal cdn url
function convertToNextImage(src: string) {
  if (src.startsWith("http://cdn-internal:8081/")) {
    return `/the-buzz/_next/image?w=1080&q=75&url=${encodeURIComponent(src)}`;
  }

  return src;
}
